import React, { createContext, useContext, useState, useCallback } from 'react'

const HelpContext = createContext()

export const HelpProvider = ({ children }) => {
    const [isHelpOpen, setIsHelpOpen] = useState(false)
    const [currentPageKey, setCurrentPageKey] = useState(null)

    const openHelp = useCallback((pageKey) => {
        setCurrentPageKey(pageKey)
        setIsHelpOpen(true)
    }, [])

    const closeHelp = useCallback(() => {
        setIsHelpOpen(false)
        setCurrentPageKey(null)
    }, [])

    return (
        <HelpContext.Provider
            value={{
                isHelpOpen,
                currentPageKey,
                openHelp,
                closeHelp,
            }}
        >
            {children}
        </HelpContext.Provider>
    )
}

export const useHelp = () => {
    const context = useContext(HelpContext)
    if (!context) {
        throw new Error('useHelp must be used within a HelpProvider')
    }
    return context
}

export default HelpContext
